import { Message } from 'element-ui';

export default {
  // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
  install: function(Vue){
    if (Vue) {
      const message = (option) => {
        Message.closeAll();
        return Message(option);
      };

      message.info = (option) => {
        Message.closeAll();
        return Message.info(option);
      };

      message.error = (option) => {
        Message.closeAll();
        return Message.error(option);
      };

      message.success = (option) => {
        Message.closeAll();
        return Message.success(option);
      };

      message.warning = (option) => {
        Message.closeAll();
        return Message.warning(option);
      };

      message.closeAll = () => {
        Message.closeAll();
        // let el = document.getElementsByClassName('x-show-modal');
        // while (el[0]) {
        //     el[0].parentNode.removeChild(el[0]);
        // }
      };

      Vue.prototype.$uxMessage = message;
    }
  }
};